<div class="flex w-full justify-center">
  <div class="relative flex flex-col w-full px-4 py-2 md:p-0 md:bg-[#FEFEFE] md:mb-12 md:max-w-[1920px]">
    <!-- Top-Header -->
    <div
      class="flex grow justify-center mb-8 md:h-[100px] md:my-0 md:mx-[60px] md:flex-row md:justify-start md:items-center">
      <!-- Main-Image -->
      <img ngSrc="assets/images/logo.png" routerLink="/main" [class]="showLogin ?'h-8 md:h-14':'h-14'"
        class="h-14 w-auto md:mr-7 md:cursor-pointer" height="116" width="459" alt="logo">
      <kaz-header-search></kaz-header-search>
    </div>
    <!-- Bottom-Header -->
    <kaz-desktop-nav>
      <div class="flex flex-row gap-4 grow justify-end items-center text-xs text-[#161D26] font-semibold">
        @if (showSignUpBtn) {
          <div
            class="flex justify-center items-center h-[33px] w-[186px] text-kaz-blue border border-kaz-blue rounded-full cursor-pointer"
            routerLink="/signup">
            <span>Konto erstellen</span>
          </div>
        }
        @if (showSignUpBtn && showLoginBtn) {
          <span class="text-sm">oder</span>
        }
        @if (showLoginBtn) {
          <div
            class="flex justify-center items-center h-[33px] w-[186px] text-white bg-[#F0811A] rounded-full cursor-pointer"
            routerLink="/login">
            <span>Anmelden</span>
          </div>
        }
      </div>
    </kaz-desktop-nav>

    @if (showLogin) {
      <a routerLink="/login"
      class="absolute right-4 top-5 text-kaz-blue font-normal text-xs underline md:hidden">Anmelden</a>
    }
    <div class="md:m-auto md:max-w-[1080px] md:w-full">
      <ng-content>
      </ng-content>
    </div>
  </div>
</div>
<kaz-footer></kaz-footer>
